export default __webpack_public_path__ + "static/media/background.dec9052f.jpg";